<template>
    <component
        :is="is"
    >
        <slot />
        <!-- <slot name="desktop"/> -->
    </component>
</template>

<script>
import { container } from '@/js/util/menu';
import dynamicComponent from '@/js/mixins/dynamic-component';

export default {
    name: 'MenuContainer',
    defaultTag: 'div',
    mixins: [dynamicComponent],
    provide() {
        return {
            [container]: this,
        };
    },
    props: {
        // menuItems: {
        //     type: Array,
        //     required: true,
        // },
    },
    data() {
        return {
            menu: [],
            menuVisible: false,
        };
    },
    created() {
        this.$on('resetMenu', this.resetMenu);
        this.$on('toggleMenu', this.toggleMenu);
    },
    beforeDestroy() {
        this.$off('resetMenu', this.resetMenu);
        this.$off('toggleMenu', this.toggleMenu);
    },
    methods: {
        resetMenu() {
            this.activeItem = undefined;
        },
        toggleMenu() {
            this.menuVisible = !this.menuVisible;
            document.body.classList.toggle('body_menu-active');
        },
    },
};
</script>



// WEBPACK FOOTER //
// src/components/navigation/MenuContainer.vue